import { Form, Button, Card, Badge, Row, Col } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import MainCard from '../../../components/MainCard';
import { IoSearch } from 'react-icons/io5';
import { useEffect, useState } from 'react';
import { FoodItemTable } from './FoodItemTable';
import { AddFoodItemPopup } from './foodItemPopup/AddFoodItemPopup';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllFoodItems, initializeMenuData } from '../../../store/slices/foodItems/foodItemsThunk';
import { setCurrentFoodItem } from '../../../store/slices/foodItems/foodItemsSlice';
// If you are using Tabler Icons or similar
import { MdLocationOn, MdPhone, MdAccessTime } from 'react-icons/md';
import { IMAGE_BASE_URL } from '../../../config';
import { FoodItemCard } from './food Item card/FoodItemCard';
import { usePermission } from '../../../hooks/usePermission';
import { PERMISSIONS } from '../../../permissions/permissions';
import { useTranslation } from 'react-i18next';
import { GlobalMenuForm } from '../category/GloablMenuForm';
import { fetchGlobalMenu } from '../../../store/slices/globalMenu/globalMenuThunk';

export function FoodItemList() {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const { t } = useTranslation()
  const handleClose = () => setShow(false);
  const foodItems = useSelector((state) => state.foodItems);
  const globalMenu = useSelector((state) => state.globalMenu);
  const dispatch = useDispatch();
  const canAddFood = usePermission(PERMISSIONS.FOOD_ITEMS.CREATE);

  useEffect(() => {
    if (!foodItems.foodItems) {
      dispatch(initializeMenuData());
    }
  }, []);

  const fetchFoodItemsAPI = () => {
    dispatch(fetchAllFoodItems());
  };

  const editFoodItem = (item) => {
    dispatch(setCurrentFoodItem(item));
    setShow(true);
  };
    // Calling Menu API
    useEffect(() => {
      
      if (!globalMenu.currentGlobalMenu) {
        dispatch(fetchGlobalMenu());
      }
    }, [dispatch]);

  if (!globalMenu.currentGlobalMenu) {
    return (
      <GlobalMenuForm/>
    )
  }

  return (
    <>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mt-3 mb-4">
        {/* Search Bar */}
        <div className="position-relative" >
          <IoSearch size={20} className="position-absolute top-50 translate-middle-y text-muted" style={{ left: '15px' }} />

          <Form.Control
            onChange={(e) => setSearch(e.target.value)}
          type="text" placeholder={t('menu_management.food.searchHere')} style={{ paddingLeft: '40px' }} />
        </div>

        {/* Add Category Button */}
        {canAddFood && (
          <Button variant="outline-dark" style={{ fontWeight: '800' }} onClick={() => setShow(true)}>
            <IoMdAdd size={20} className="me-2" />
           {t('menu_management.food.addFoodItem')}
          </Button>
        )}
      </div>
      {/* Category Table */}
      <FoodItemTable fetchFoodItem={fetchFoodItemsAPI} editFoodItem={editFoodItem} search={search} />
      <AddFoodItemPopup show={show} handleClose={handleClose} fetchFoodItems={fetchFoodItemsAPI} />
    </>
  );
}
